export default __webpack_public_path__ + "static/media/treesA_cluster00.df43af5c.png";